import React from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import QwietAICredentialsForm from './QwietAICredentialsForm'
import QwietAIMappingForm from './QwietAIMappingForm'

export default function QwietAIConfigListing(props) {
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={QwietAIMappingForm}
            CredentialsForm={QwietAICredentialsForm}
            componentName="Project"
            componentKey="applicationName"
        />
    )
}